<div class="panel">
    <mat-card>
        <mat-card-header>
          <mat-card-title><a [routerLink]="link">{{ header }}</a></mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <ng-content select="[panel-body]"></ng-content>
        </mat-card-content>
        <mat-card-actions>
            <div fxLayout="row" fxLayoutAlign="{{_footerPos}}">
                <button [style.background-color]="footerColor" mat-button>{{ footer }}</button>
            </div>
        </mat-card-actions>
    </mat-card>    
</div>

<style lang="scss">
.panel .mat-card {
    padding: 0;
}

.panel .mat-card-actions, 
.panel .mat-card-content, 
.panel .mat-card-subtitle, 
.panel .mat-card-title {
    margin-bottom: 0;
}

.panel .mat-card-header {
    background: #696969;
}

.panel .mat-card-title {
    padding: 10px;
    font-size: 16px;
    font-weight: 700;
    color: white;
}

.panel .mat-card-title a {
    text-transform: uppercase;
}

.panel .mat-card-content {
    /* padding: .6em 1em;
    margin: 10px 0; */
    /* max-height: 100px; */
    overflow-y: scroll;
}

.panel .mat-card-actions {
    margin: 0;
    padding: 0;
    background: gainsboro;
}

</style>
